import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'common';
import { recipesSlice, selectRecipesGridData, updateSecretRecipeHeaders } from 'common/src/store/recipes';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CfCheckbox } from '../../../cf-ui/CheckboxList/components/Checkbox/CfCheckbox';
import { CfDialog } from '../../../cf-ui/dialogs/Dialog/CfDialog';
import { getResolution } from '../../../utilities/resolution';
import { RecipeContainedGrid } from '../../recipes/components/RecipeContainedGrid/RecipeContainedGrid';

export type SecretRecipesDialogProps = {
  onClose: () => void;
};

const SecretRecipesDialog: FC<SecretRecipesDialogProps> = (props: SecretRecipesDialogProps): JSX.Element => {
  const { onClose } = props;
  const dispatch = useAppDispatch();
  const { customerId } = useParams<{ customerId: string }>();

  const [filterText, setFilterText] = useState<string>('');
  const [changedSecretRecipes, setChangedSecretRecipes] = useState<Record<string, boolean>>({});

  const recipesGridData = useAppSelector((s) =>
    selectRecipesGridData(s, filterText, undefined, undefined, undefined, undefined, true, true)
  );

  const handleVisibilityChange = (recipeId: string, isPrivate: boolean) => {
    setChangedSecretRecipes((prevState) => ({
      ...prevState,
      [recipeId]: isPrivate,
    }));
  };

  const handleUpdate = async () => {
    const updatedPrivateRecipeList = Object.entries(changedSecretRecipes).map(([recipeHeaderId, isHidden]) => ({
      RecipeHeaderId: recipeHeaderId,
      IsAdd: isHidden,
    }));

    if (!updatedPrivateRecipeList.length) return;

    dispatch(updateSecretRecipeHeaders(updatedPrivateRecipeList, customerId, getResolution()));
    onClose();
  };

  const handleClose = () => {
    dispatch(recipesSlice.actions.updateAllCategoryIsCollapsed(false));
    onClose();
  };

  return (
    <CfDialog
      title='Manage Secret recipes'
      isOpen={true}
      onClose={handleClose}
      primaryButtonProps={{
        children: 'Save',
        onClick: handleUpdate,
      }}
      secondaryButtonProps={{
        children: 'Cancel',
        onClick: handleClose,
      }}
      paperSx={{
        width: 450,
      }}
    >
      <RecipeContainedGrid
        id='secret-recipes'
        recipeHeaders={recipesGridData}
        handleFilter={setFilterText}
        filterText={filterText}
        renderActionComponentLeft={(recipeHeader) => {
          const isChecked = changedSecretRecipes?.[recipeHeader.RecipeHeaderId] ?? recipeHeader.IsPrivate;
          return (
            <Box sx={{}}>
              <CfCheckbox
                variant='primary'
                onCheckedChanged={(i) => handleVisibilityChange(recipeHeader.RecipeHeaderId, i.checked)}
                item={{
                  label: '',
                  checked: isChecked,
                  disabled: !recipeHeader.CanViewDetails,
                }}
              />
            </Box>
          );
        }}
      />
    </CfDialog>
  );
};

export default SecretRecipesDialog;
